import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout, PageHeader } from "../../components/v3";
import { AddEditIncomeForm } from "../../components/client";

export const AddEditIncome = () => {
  const { incomeId } = useParams();

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title={incomeId ? "Edit Income" : "Add Income"}
          />
        </Box>

        {/* form section */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <CardLayout>
            <AddEditIncomeForm />
          </CardLayout>
        </Box>
      </PageLayout>
    </>
  );
};
